/**
 * Optional money fields, where blank and zero mean different things.
 *
 * A rate's Credit Card Hold and Minimum Wallet Balance both fall back to the
 * system setting when they are not set, so a $0 hold ("charge this rider
 * nothing") is a real value and has to survive the round trip separately from
 * "left blank". `Number('')` is 0 and 0 is falsy, so the usual
 * `Number(e.target.value)` / `value ? value * 100 : null` pair collapses the
 * two: entering 0 saved as null and came back reading "(not set)".
 *
 * `null` is blank here; every number, zero included, is a value.
 */

/** Read a number input's value, keeping an emptied field distinct from 0. */
export function toAmount(value: string): number | null {
  if (value.trim() === '') return null;
  const amount = Number(value);
  // A number input hands over '' for most nonsense, but a lone '-' or 'e'
  // arrives as typed and parses to NaN, which is not an amount either.
  return Number.isNaN(amount) ? null : amount;
}

/** Turn an optional dollar amount into whole cents, leaving blank blank. */
export function toCents(amount: number | null): number | null {
  return amount === null ? null : Math.round(amount * 100);
}
